import { render, staticRenderFns } from "./lazada-order.vue?vue&type=template&id=1216c5dd&"
import script from "./lazada-order.vue?vue&type=script&lang=js&"
export * from "./lazada-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports